import { BillingLineDiscountDto } from "@app/modules/shared/model/billing/billing-line-discount.dto";
import { BillingDiscountDto } from "@app/modules/shared/model/billing/billing-discount.dto";

export class BillingCalculationDiscountDto {
  net_unit_amount?: number;
  line_amount?: number;
  document_amount?: number;
  lineDiscounts: Array<BillingLineDiscountDto>;
  discounts: Array<BillingDiscountDto>;
}
